import { useCallback, useContext } from "react";
import { AuthContext, fp } from "../App";
import Constants from "../utils/Constants";
import { useFetch } from "../hooks/useFetch";

const adminBaseUrl = Constants.SERVER_URL + "/wapi";
const publicBaseUrl = Constants.SERVER_URL + "/wapi-501/chargebee";

const useChargebee = () => {
  const { authState } = useContext(AuthContext);
  const { send } = useFetch();

  const findPlan = useCallback(
    async (query) => {
      const config = {
        method: "get",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
      };

      return await send(publicBaseUrl + "/plans?", config);
    },
    [authState.token, send]
  );

  const createSubscription = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
        body: JSON.stringify(params),
      };

      return await send(publicBaseUrl + "/subscriptions", config);
    },
    [authState.token, send]
  );

  //   const update = useCallback(
  //     async (id, params) => {
  //       const config = {
  //         method: "post",
  //         headers: {
  //           Authorization: "Bearer " + authState.token,
  //           "Content-Type": "application/json",
  //           FpId: (await fp).visitorId,
  //         },
  //         body: JSON.stringify(params),
  //       };

  //       return await send(adminBaseUrl + "/wapi/blanketOrderDetails/" + id, config);
  //     },
  //     [authState.token, send]
  //   );

  //   const destroy = useCallback(
  //     async (id, params) => {
  //       const config = {
  //         method: "delete",
  //         headers: {
  //           Authorization: "Bearer " + authState.token,
  //           "Content-Type": "application/json",
  //           FpId: (await fp).visitorId,
  //         },
  //         body: JSON.stringify(params),
  //       };

  //       return await send(adminBaseUrl + "/wapi/blanketOrderDetails/" + id, config);
  //     },
  //     [authState.token, send]
  //   );

  return { findPlan, createSubscription };
};

export { useChargebee };
